<template>
  <div>
    <template v-if="contents">
      <div :class="['component', previewSize]" :style="hideAll ? 'display:none' : ''">
        <div @click="isEditing = !isEditing">

          <section :class="sectionClassArray" :style="sectionStyle">
            <div :class="containerClassArray">
              <template v-if="contents.items.length">
                <div :class="this.gridClassArray">
                  <template v-for="(item, index) in contents.items">
                    <div>
                      <span class="link-button block fit-width theme-accent-border-color theme-accent-bg-color-hover text-center bold p2">{{ item.text }}</span>
                    </div>
                  </template>
                </div>
              </template>
              <template v-else>
                <div class="component-warning flex justify-center items-center">
                  <span class="component-warning-span">リンクを追加してください</span>
                </div>
              </template>
            </div>
          </section>
        </div>
      </div>

      <el-form :class="['component-contents-form', ' p2', lock ? 'hide' : isEditing ? 'show' : 'hide']" :model="contents">
        <h2>コンポーネントのコンテンツを編集</h2>
        <el-form-item label="コンポーネント配置順序" label-width="170px">
          <el-input-number v-model="newPosition" controls-position="right" :min="1" :max="positionMax"></el-input-number><span class="pl4">1から{{ positionMax }}まで</span>
        </el-form-item>
        <el-form-item label="リンクボタンの設定" label-width="170px">
          <template v-for="(item, index) in contents.items">
            <div class="flex items-center my1">
              <div class="flex column items-center">
                <el-button class="my1" style="margin-left:0" @click="onDeleteLink(index)">リンクボタンの削除</el-button>
              </div>
              <div class="ml2">
                <el-input class="width-100" v-model="item.text" auto-complete="off" placeholder="リンクボタンのテキスト"></el-input>
                <el-input class="width-100" v-model="item.href" auto-complete="off" placeholder="リンク先URL"></el-input>
                <el-checkbox v-model="item.blank">リンク先を新たなタブで開く</el-checkbox>
              </div>
            </div>
          </template>
          <el-button class="my1" @click="onAddLink">リンクボタンの追加</el-button>
        </el-form-item>
        <el-form-item label="スマホサイズで横に並べるリンクボタンの数" :label-width="labelWidth">
          <el-input-number v-model="contents.layout.s" controls-position="right" :min="1" :max="2"></el-input-number><span class="pl4">最大2まで</span>
        </el-form-item>
        <el-form-item label="タブレットサイズで横に並べるリンクボタンの数" :label-width="labelWidth">
          <el-input-number v-model="contents.layout.m" controls-position="right" :min="1" :max="3"></el-input-number><span class="pl4">最大3まで</span>
        </el-form-item>
        <el-form-item label="デスクトップサイズで横に並べるリンクボタンの数" :label-width="labelWidth">
          <el-input-number v-model="contents.layout.l" controls-position="right" :min="1" :max="4"></el-input-number><span class="pl4">最大4まで</span>
        </el-form-item>
        <el-form-item label="リンクボタン間の余白" :label-width="labelWidth">
           <el-slider v-model="contents.layout.margin" :step="1" :min="0" :max="5"></el-slider>
        </el-form-item>
        <el-form-item label="スライド上下の余白" :label-width="labelWidth">
           <el-slider v-model="contents.padding.y" :step="1" :min="0" :max="10"></el-slider>
        </el-form-item>
        <el-form-item label="スライド背景色" :label-width="labelWidth">
          <div>
            <el-checkbox v-model="contents.bg.isCustom">スライドの背景色を指定する</el-checkbox>
          </div>
          <div class="items-center" :style="{display: contents.bg.isCustom ? 'flex' : 'none'}">
            <el-color-picker v-model="contents.bg.color" show-alpha></el-color-picker>
            <span>{{ contents.bg.color }}</span>
          </div>
        </el-form-item>
        <div class="component-contents-controller flex justify-end items-center">
          <component-form-footer @delete="deleteComponent()" @cancel="isEditing = false" @update="updateComponent()"></component-form-footer>
        </div>
      </el-form>
    </template>
  </div>
</template>

<script>
import ComponentBase from '@/components/mixins/ComponentBase'

export default {
  name: 'link-buttons-1',
  mixins: [ComponentBase],
  data: function () {
    return {
      labelWidth: '20em',
      dialogImageSelectVisible: false
    }
  },
  methods: {
    onAddLink: function () {
      this.contents.items.push({
        href: '',
        text: 'リンク先テキスト',
        color: '',
        blank: false
      })
    },
    onDeleteLink: function (index) {
      this.contents.items.splice(index, 1)
    },
    /**
     * this.contentsからコンポーネントのHTMLを生成
     */
    generateHtml: function (contents) {
      const linkButtons = contents.items.reduce((acc, item) => {
        const blank = item.blank ? 'target="_blank"' : ''
        return acc + (`<div><a class="link-button block fit-width theme-accent-border-color theme-accent-bg-color-hover text-center bold p2" href="${item.href}" ${blank}>${item.text}</a></div>`)
      }, '')

      return `
      <section id="${this.sectionId}" class="${this.sectionClass}">
        <div class="${this.containerClass}">
          <div class="${this.gridClass}">
            ${linkButtons}
          </div>
        </div>
      </section>`.trim().replace(/>\s+</g, '><')
    },
    /**
     * this.contentsからコンポーネントのCSSを生成
     */
    generateCss: function (contents) {
      let layout = require(`!css-to-string-loader!css-loader?minimize!sass-loader!./${this.meta.file}.scss`)
      let theme = contents.bg.isCustom ? `.${this.meta.file}-${this._uid}-bg{background-color:${contents.bg.color}}` : ''
      return {layout, theme}
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~scss/variables';
@import '~scss/theme';

.native {
  @import './LinkButtons1.scss';
}
.smartphone,
.tablet,
.desktop {
  @import './LinkButtons1.s.scss';
}
.tablet,
.desktop {
  @import './LinkButtons1.m.scss';
}
.desktop {
  @import './LinkButtons1.l.scss';
}
</style>


// WEBPACK FOOTER //
// src/components/contents/LinkButtons1/LinkButtons1.vue